import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const propTypes = {
  id: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  type: PropTypes.string.isRequired,
  model: PropTypes.string.isRequired,
  children: PropTypes.func,
  hidden: PropTypes.bool,
};

const AlwaysVisibleHack = styled.div`
  display: block !important;
  position: relative;
`;

const Tooltip = styled.span`
  position: absolute;
  top: 0;
  left: 3px;
`;

const UpLift = ({ id, value, type, model, children, hidden = false }) => {
  //we need to pass the component to the children, because when having tried to pass the value, the cildren did not re-render properly when content changed
  const UpliftMonthlyAmount = <span data-g4-from-currency-unit-major></span>;

  const tooltip = <Tooltip data-up-tooltip></Tooltip>;

  return (
    <AlwaysVisibleHack
      data-g4-id={id}
      data-g4-price-value={value}
      data-g4-price-type={type}
      data-g4-price-model={model}
    >
      {!hidden && children(UpliftMonthlyAmount, tooltip)}
    </AlwaysVisibleHack>
  );
};

UpLift.propTypes = propTypes;

export default UpLift;
